import React, { forwardRef, useRef, useState, useEffect } from "react";
import UserInputBarWithSendOnly from "./UserInputBarWithSendOnly";
import SocketMicStreamer from "./SocketMicStreamerNewUi";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { setInputValue } from "../../../store/features/ui/uiSlice";

import {
  selectIsHideUserInputFields,
  selectSelectedChatId,
} from "../../../store/features/message/textContentSelectors";
import { updateFlowStates } from "../../../store/features/message/updateFlowStates";

const SepratedInputChnages = forwardRef(
  ({ handleSend, onKeyDown, isUserInputBar, isTypingRef }, ref) => {
    const dispatch = useDispatch();
    const selectedChatId = useSelector(selectSelectedChatId);
    const isHideUserInputBar = useSelector(selectIsHideUserInputFields);

    const micStreamerRef = useRef(null);

    const [isTextareaVisible] = useState(false);
    const [onDynamicFormSubmit] = useState(false);
    const [getFormAnswers] = useState(null);

    // ADD THIS: Detect mobile device
    const [isMobile, setIsMobile] = useState(false);

    const handleSearchChange = (e) => {
      dispatch(setInputValue(e.target.value));
      dispatch(updateFlowStates());
    };

    // ADD THIS: Mobile detection effect
    useEffect(() => {
      const checkMobile = () => {
        setIsMobile(window.innerWidth < 768); // 768px is md breakpoint
      };

      checkMobile();
      window.addEventListener("resize", checkMobile);
      return () => window.removeEventListener("resize", checkMobile);
    }, []);

    useEffect(() => {
      if (
        onDynamicFormSubmit &&
        getFormAnswers &&
        Object.keys(getFormAnswers).length > 0
      ) {
        dispatch(setInputValue(Object.values(getFormAnswers).join(",")));
        dispatch(updateFlowStates());
      }
    }, [onDynamicFormSubmit, getFormAnswers, dispatch]);

    return (
      <>
        {!isHideUserInputBar && (
          <div className="relative w-full">
            {/* CHANGE THIS: Conditional positioning based on device */}
            {selectedChatId && !isMobile && (
              <div className="absolute left-1/2 -top-[50px] transform -translate-x-1/2 z-20">
                <SocketMicStreamer
                  key="mic-streamer-input"
                  ref={micStreamerRef}
                  isUserInputBar={isUserInputBar}
                  onAutoSend={handleSend}
                />
              </div>
            )}

            {/* CHANGE THIS: Add flex and pass isMobile prop */}
            <div className="flex items-center gap-2  p-2 rounded-xl shadow-md">
              {!isTextareaVisible && (
                <UserInputBarWithSendOnly
                  isTypingRef={isTypingRef}
                  onChange={handleSearchChange}
                  onKeyDown={onKeyDown}
                  handleSend={handleSend}
                />
              )}

              {/* ADD THIS: Mic button inline on mobile */}
              {selectedChatId && isMobile && (
                <SocketMicStreamer
                  key="mic-streamer-input"
                  ref={micStreamerRef}
                  isUserInputBar={isUserInputBar}
                  onAutoSend={handleSend}
                />
              )}
            </div>
          </div>
        )}
      </>
    );
  }
);

SepratedInputChnages.propTypes = {
  handleSend: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  isUserInputBar: PropTypes.bool,
  isTypingRef: PropTypes.object,
};

SepratedInputChnages.displayName = "SepratedInputChnages";
export default SepratedInputChnages;
